var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quillWrapper"},[_vm._t("toolbar"),_c('div',{ref:"quillContainer",attrs:{"id":_vm.id}}),(_vm.useCustomImageHandler)?_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"id":"file-upload","accept":"image/*","type":"file"},on:{"change":function($event){return _vm.emitImageInfo($event)}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }